export const trustSignals = [
  {
    title: { en: 'Licensed & Insured', es: 'Licenciados y Asegurados' },
    description: {
      en: 'All work is fully licensed and insured for your peace of mind.',
      es: 'Todo el trabajo está completamente licenciado y asegurado para tu tranquilidad.',
    },
  },
  {
    title: { en: 'Years of Experience', es: 'Años de Experiencia' },
    description: {
      en: 'Decades of expertise delivering quality concrete and asphalt services.',
      es: 'Décadas de experiencia entregando servicios de concreto y asfalto de calidad.',
    },
  },
  {
    title: { en: 'Professional Team', es: 'Equipo Profesional' },
    description: {
      en: 'Skilled, trained craftsmen dedicated to excellence and quality.',
      es: 'Artesanos capacitados y entrenados dedicados a la excelencia y la calidad.',
    },
  },
  {
    title: { en: 'Free Estimates', es: 'Estimados Gratis' },
    description: {
      en: 'No-obligation, detailed estimates on all projects.',
      es: 'Estimados detallados sin obligación en todos los proyectos.',
    },
  },
  {
    title: { en: 'Customer Satisfaction Guaranteed', es: 'Satisfacción Garantizada' },
    description: {
      en: 'Guaranteed. We stand behind every project and every client.',
      es: 'Garantizado. Respaldamos cada proyecto y cada cliente.',
    },
  },
  {
    title: { en: 'Local Business', es: 'Negocio Local' },
    description: {
      en: 'Serving Chicagoland and surrounding communities for years.',
      es: 'Sirviendo Chicagoland y comunidades circundantes durante años.',
    },
  },
];
